import "../styles/TemplateLegendItemElement.css";
import {useContext} from "react";
import {SelectedContext} from "../pages/MapEditor";

const LegendItemElement = ({ item }) => {
    const { selectedLegendItem, setSelectedLegendItem } = useContext(SelectedContext);

    return (
        <>
            <div className="LegendItemElement">
                <div className={`self ${selectedLegendItem === item.id ? 'selected' : ''}`}
                     onClick={e => {e.stopPropagation(); setSelectedLegendItem(item.id)}}
                     tabIndex={0} onContextMenu={e => e.preventDefault()}>
                    <span className="color" style={{ background: item.color }}/>
                    <p className="name">{item.name}</p>
                </div>
            </div>
        </>
    );
}

export default LegendItemElement;
